import React, { useEffect, useId, useState } from "react";
import PropTypes from "prop-types";
import {
  PROFILE_MENU,
  STAFF_SIDEBAR_MENU,
  announceOverlayMenuOpen,
  onOtherOverlayMenuOpen,
} from "../utils/exclusiveOverlayMenus";

function ResponsiveActionSidebar({
  id = "",
  className,
  openClassName = "",
  toggleClassName = "",
  label = "Menú",
  ariaLabel = "Navegación de acciones",
  children,
  closeOnAction = true,
}) {
  const generatedId = useId();
  const sidebarId = id || `responsive-action-sidebar-${generatedId}`;
  const [open, setOpen] = useState(false);
  const asideClassName = [
    className,
    "staff-action-sidebar",
    open ? "staff-action-sidebar--open" : "",
    open && openClassName ? openClassName : "",
  ].filter(Boolean).join(" ");

  const handleSidebarClick = (event) => {
    if (!closeOnAction) return;
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    if (target.closest("a, button")) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (!open) return undefined;
    document.body.classList.add("staff-sidebar-drawer-open");
    announceOverlayMenuOpen(STAFF_SIDEBAR_MENU);
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.classList.remove("staff-sidebar-drawer-open");
    };
  }, [open]);

  useEffect(() => (
    onOtherOverlayMenuOpen(STAFF_SIDEBAR_MENU, () => setOpen(false), {
      compatibleMenus: [PROFILE_MENU],
    })
  ), []);

  return (
    <>
      <div className="staff-sidebar-toggle-slot">
        <button
          type="button"
          className={["staff-sidebar-toggle", toggleClassName].filter(Boolean).join(" ")}
          onClick={() => setOpen((current) => !current)}
          aria-expanded={open}
          aria-controls={sidebarId}
        >
          ☰ {label}
        </button>
      </div>
      {open && (
        <button
          type="button"
          className="staff-sidebar-backdrop"
          aria-label="Cerrar menú"
          onClick={() => setOpen(false)}
        />
      )}
      <aside
        id={sidebarId}
        className={asideClassName}
        aria-label={ariaLabel}
        onClick={handleSidebarClick}
      >
        {children}
      </aside>
    </>
  );
}

ResponsiveActionSidebar.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string.isRequired,
  openClassName: PropTypes.string,
  toggleClassName: PropTypes.string,
  label: PropTypes.string,
  ariaLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
  closeOnAction: PropTypes.bool,
};

export default ResponsiveActionSidebar;
